/* eslint-disable no-console */
/* eslint-disable no-underscore-dangle */
import { MenuTools, Wrap } from './styles';

import IdentifyFeatureCoordinates from '../IdentifyFeatureCoordinates';
import IdentifyFeatureLocation from '../IdentifyFeatureLocation';
import IdentifyFeature from '../IdentifyFeatureMap';



import ButtonTooltip from '@map/components/ToolBar/components/ButtonTooltip';
/**
 * Tooltip é uma ferramenta utilizada para especificar informações extras
 * sobre algo quando o usuário move o ponteiro do mouse sobre um elemento.
 */
import Tooltip from 'components/Tooltip';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 */
import { useState, useEffect } from 'react';
/**
 *  useModules é responsavel por gerenciar os modulos do GeoBahia,
 *  todos os módulos criados na ADM.
 */
import { useModule } from 'views/MapView/hooks';

/**
 * Ferramenta de Identificação de Feições
 * 
 * @param {string} mapContext Context
 * @param {boolean} isActive Verificação
 * @param {boolean} setIsActive Seta o estado
 * @returns Um menu onde esta a ferramenta buffer
 */
export const IdentificationTools = ({ mapContext, isActive, setIsActive }) => {    
  const [activeTool, setActiveTool] = useState(null);

  // Estados de SUBMENU
  const [anchorToolOptions, setAnchorToolOptions] = useState(null);
  
  useEffect(() => {
    if (!isActive) setAnchorToolOptions(null);
  }, [isActive]);
  
  const { getElement, activeModule } = useModule();    

  const handleActiveTool = (toolName) => {
    setActiveTool(activeTool === toolName ? null : toolName);
  };

  // Observando se a ferramenta está ativa
  useEffect(() => {
    if (isActive) {      
      setActiveTool(null); // Desativa a ferramenta
    }
  }, [isActive]);

  const Icon = (props) => (
    <svg
      width="28"
      height="29"
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.08889 9.00783C11.3556 5.74117 16.6444 5.74117 19.9111 9.00783C21.4667 10.5634 22.3378 12.6167 22.3533 14.8101C22.3844 16.9878 21.56 19.0567 20.0667 20.6434L13.9844 26.7256L8.02667 20.7678C4.82222 17.5012 4.85333 12.2434 8.08889 9.00783ZM7 7.91895C3.15778 11.7612 3.12667 17.9834 6.93778 21.8567L14 28.9189L21.1867 21.7323C24.8578 17.8434 24.7956 11.7145 21 7.91895C17.1267 4.04561 10.8733 4.04561 7 7.91895Z"
        fill={props.fill || 'currentColor'}
      />
      <path
        d="M15.0732 11.1184C15.0732 11.4091 14.9614 11.655 14.7378 11.8786C14.5143 12.0798 14.2683 12.1916 13.9553 12.1916C13.7988 12.1916 13.6646 12.1692 13.5305 12.1022C13.3964 12.0351 13.2846 11.968 13.1728 11.8786C13.061 11.7892 12.9939 11.6774 12.9268 11.5432C12.8598 11.4091 12.8374 11.2749 12.8374 11.1408C12.8374 11.0066 12.8598 10.8948 12.9268 10.7607C12.9939 10.6265 13.061 10.5371 13.1728 10.4253C13.2846 10.3359 13.3964 10.2465 13.5305 10.2017C13.6646 10.1347 13.7988 10.1123 13.9553 10.1123C14.1118 10.1123 14.246 10.1347 14.3801 10.2017C14.5143 10.2688 14.626 10.3359 14.7378 10.4253C14.8496 10.5147 14.9167 10.6265 14.9838 10.7383C15.0508 10.8501 15.0732 10.9843 15.0732 11.1184ZM14.9614 19.4132C14.9614 19.7262 14.872 19.9722 14.6931 20.151C14.5143 20.3299 14.2683 20.4417 13.9777 20.4417C13.687 20.4417 13.4411 20.3523 13.2622 20.151C13.0833 19.9722 12.9939 19.7039 12.9939 19.4132V14.2932C12.9939 13.9802 13.0833 13.7343 13.2622 13.5331C13.4411 13.3542 13.687 13.2424 13.9777 13.2424C14.2683 13.2424 14.5143 13.3319 14.6931 13.5331C14.872 13.7119 14.9614 13.9802 14.9614 14.2932V19.4132Z"
        fill={props.fill || 'currentColor'}
      />
    </svg>
  );

  return (
    <Wrap>      
      <ButtonTooltip
        tooltip={IdentificationTools.properties.alias}
        description={IdentificationTools.properties.description}
        onClick={(e) => {          
          setIsActive(!isActive);
          setAnchorToolOptions(anchorToolOptions ? null : e.currentTarget);
        }}
        tooltipDisabled={isActive}
        active={isActive}
      >        
        <Icon width="24" height="24" />
      </ButtonTooltip>
      <MenuTools 
        className={`${
            isActive && 'active'
        }`}
      >
        {activeModule &&
          getElement(IdentificationTools.properties.id)?.configuracao.identifyFeature !== false && (
            <div className="tool identify">
              <Tooltip>
                <IdentifyFeature
                  mapContext={mapContext}
                  isActive={isActive && activeTool === 'CPN-TB-A-IDENTIFY-FEATURE'}              
                  setIsActive={() => handleActiveTool('CPN-TB-A-IDENTIFY-FEATURE')}
                />
              </Tooltip>
            </div>
          )
        }
        {activeModule &&
          getElement(IdentificationTools.properties.id)?.configuracao.identifyFeatureCoordinates !== false && (
            <div className="tool identify">
              <Tooltip>
                <IdentifyFeatureCoordinates
                  mapContext={mapContext} // TODO: Verificar se é necessário
                  isActive={isActive && activeTool === 'CPN-TB-A-IDENTIFY-COORDINATES-FEATURE'}//      
                  setIsActive={() => handleActiveTool('CPN-TB-A-IDENTIFY-COORDINATES-FEATURE')}
                />
              </Tooltip>
            </div>
          )
        }
        {activeModule &&
          getElement(IdentificationTools.properties.id)?.configuracao.identifyFeatureLocation !== false && (
            <div className="tool identify">
              <Tooltip>
                <IdentifyFeatureLocation
                  mapContext={mapContext} // TODO: Verificar se é necessário
                  isActive={isActive && activeTool === 'CPN-TB-A-IDENTIFY-FEATURE-LOCATION'}//      
                  setIsActive={() => handleActiveTool('CPN-TB-A-IDENTIFY-FEATURE-LOCATION')}
                />
              </Tooltip>
            </div>
          )
        }
      </MenuTools>
    </Wrap>
  );
};

IdentificationTools.properties = {
  id: 'CPN-TB-A-IDENTIFICATION-TOOLS',
  alias: 'Ferramentas de identificação',
  description:
    'Ferramentas de identificação de feições.',
  configurable: true,
};

export default IdentificationTools;
